import { CancelButton } from "elements";
import { useState } from "react";
import { ResourceFilesTable } from "routes/Manage/ResourceFiles/ResourceFiles";
import { TABLES } from "store/userMeta";
import { useTranslation } from "utilities/i18n";

export const ResourceFileSelector: React.FC<{
  selectedFile: string;
  onSelect: (selection: string) => void;
  onClose: () => void;
}> = ({ selectedFile, onSelect, onClose }) => {
  const { t } = useTranslation();
  const [selectedResource, setSelectedResource] = useState<string>(
    selectedFile
  );

  const { COLUMNS } = TABLES.RESOURCE_FILES;

  const onSubmit = () => {
    if (selectedResource) {
      onSelect(selectedResource);
    }
    onClose();
  };

  return (
    <div className="modal">
      <div className="overlay" onClick={onClose} />
      <div className="modal-content">
        <h4>{t("SELECT_RESOURCE_FILE")}</h4>
        <div className="mt-2">
          <ResourceFilesTable
            shownColumns={Object.values(COLUMNS)}
            hiddenColumns={[]}
            singleSelection
            selected={selectedResource ? [selectedResource] : undefined}
            onSelect={setSelectedResource}
            inModal
          />
        </div>
        <div className="btn-container">
          <CancelButton onClick={onClose} />
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSubmit}
            disabled={!selectedResource}
          >
            {t("OK")}
          </button>
        </div>
      </div>
    </div>
  );
};
